module.exports = {
  siteTitle: 'Cut Above Agency',
  siteUrl: 'https://shop.cutaboveagency.com',
  uploadsUrl: 'https://shop.cutaboveagency.com/wp-content/uploads/',
  siteLogo: '2021/02/logo-main.png',
}
